import { useCallback, useEffect, useState } from 'react';
import { getAllElectronicInvoiceAddresses } from 'src/shared/services/electronicInvoiceAddressService';

/** Returns the number of pending e-invoice applications (eInvoiceReceiver_id IS NULL) and a refetch function */
export const useEInvoiceApplicationsBadge = (enabled = true): [number, () => void] => {
  const [pendingCount, setPendingCount] = useState(0);

  const fetch = useCallback(() => {
    if (!enabled) return;
    getAllElectronicInvoiceAddresses({ pageIndex: 0, pageSize: 1, sortCol: 'eInvoiceAddress_id', sortDir: 'desc', filter: '' }, true)
      .then((res) => {
        setPendingCount(res.data.totalItems);
      })
      .catch(() => undefined);
  }, [enabled]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return [pendingCount, fetch];
};
